import { encode } from "base64-arraybuffer";
export const OriginalWorker = window.Worker;

/**
 * HMR using a different origin doesn't allow different CORS.
 * This is a workaround: Since the only way to use a web-worker in our project is via WebPack,
 * we can just monkey-patch the worker with one that loads a blob.
 */
export class CorsWorker extends Worker {
    constructor(url: string|URL) {
        const blobUrl = URL.createObjectURL(new Blob([`import "${url.toString()}"`], {type: "application/javascript"}));
        super(blobUrl, {type: "module"});
        URL.revokeObjectURL(blobUrl);
    }
}


const te = new TextEncoder();


export class SharedCorsWorker extends SharedWorker {
    constructor(url: string|URL, options: any) {
        // const script = `import "${url.toString()}"`;
        // const dataURL = "data:application/javascript;base64," + encode(te.encode(script).buffer);
        // super(dataURL, options);
        super(`/shared_worker?header=${encodeURIComponent(url.toString())}`, options);
    }
}


window.Worker = CorsWorker;
window.SharedWorker = SharedCorsWorker;
